import moment from "moment";
import apiCalls from "src/api/apiCalls";
import { badge } from "src/utils/statusColorsCode";
export const CustomCheckBox = ({ checkBoxData, handleCheckboxChanges, data }) => {
    return (
        <td>
            <label htmlFor className="text-center custom-checkbox cursor-pointer cust-check-outline">
                <input
                    id={data.dataItem?.id}
                    name="check"
                    type="checkbox"
                    checked={checkBoxData?.id === data.dataItem?.id}
                    onChange={(e) => handleCheckboxChanges(e, data)}
                    className="cursor-pointer"
                />
                <span></span>
            </label>
        </td>
    )
}
export const getCaseDetails = async (id) => {
    try {
        const response = await apiCalls.featchCaseDetails(id);
        if (response.status === 200) {
            return { data: response.data, error: '' }
        }
        return { data: null, error: apiCalls.isErrorDispaly(response) }
    } catch (error) {
        return { data: null, error: apiCalls.isErrorDispaly(error) }
    }
}
export const getCaseStateLu = async (screenName, state) => {
    try {
        const response = await apiCalls.featchCaseSatateLu(screenName, state);
        if (response.status === 200) {
            return { data: response.data, error: '' }
        }
        return { data: null, error: apiCalls.isErrorDispaly(response) }
    } catch (error) {
        return { data: null, error: apiCalls.isErrorDispaly(error) }
    }
}
export const getAdmins = async () => {
    try {
        const name = null;
        const response = await apiCalls.assignedAdmins(name);
        if (response.status === 200) {
            return { data: response.data, error: '' }
        }
        return { data: null, error: apiCalls.isErrorDispaly(response) }
    } catch (error) {
        return { data: null, error: apiCalls.isErrorDispaly(error) }
    }
}
export const deleteCaseAssigners = async (id) => {
    try {
        const response = await apiCalls.deleteCaseAssigners(id);
        if (response.status === 200) {
            return { data: response.data, error: '' }
        }
        return { data: null, error: apiCalls.isErrorDispaly(response) }
    } catch (error) {
        return { data: null, error: apiCalls.isErrorDispaly(error) }
    }
}
export const getTemplates = async () => {
    try {
        const response = await apiCalls.casesTemplate();
        if (response.status === 200) {
            return { data: response.data, error: '' }
        }
        return { data: null, error: apiCalls.isErrorDispaly(response) }
    } catch (error) {
        return { data: null, error: apiCalls.isErrorDispaly(error) }
    }
}
export const CaseNumberHandler = ({ caseViewHandler, data }) => {
    return (
        <td>
            <span onClick={caseViewHandler(data)} className='text-link'>{data?.caseNumber}</span>
        </td>
    )
}
export const CreatedDateHandler = ({ data }) => {
    return (
        <td>
            {data?.createdDate ? <> {moment.utc(data?.createdDate).local().format("DD/MM/YYYY hh:mm:ss A")}</> : data?.createdDate}
        </td>
    )
}
export const CaseStateHandler = ({ data }) => {
    return (
        <td>
            <span className={`status-badge ${badge[data?.state?.toLowerCase()] || 'bg-green'}`}>{data?.state}</span>
        </td>
    )
}
export const TemplateNameHandler = ({ data,handleEditModel }) => {
    return (
        <td>
            <span onClick={handleEditModel(data)} className='text-link'>{data?.templateName}</span>
        </td>
    )
}